export function generateLevelParams(
  fields: string[],
  prefix: string,
  length = 3,
  parentKey = "parent"
) {
  return Array.from({ length })
    .map((_, index) => {
      return fields.map((i) => {
        const center = Array.from({ length: index }).map(() => parentKey);
        return [prefix, ...center, i].join(".");
      });
    })
    .flat();
}
